import {
  EVENT_TYPE_VALUES_SET,
  EVENT_TYPE_VALUES_REQ,
  EVENT_TYPE_VALUES_SUCCESS,
  EVENT_TYPE_VALUES_ERROR,
  EVENT_TYPE_VALUES_RESET_STATUS
} from './query-fields.type'

import ApiRest from '@/api/api-rest'

const state = {
  eventTypeValuesReqStatus: '',
  eventTypeValues: {}
}

const getters = {
  eventTypeValuesReqStatus: state => state.eventTypeValuesReqStatus,
  eventTypeValues: state => state.eventTypeValues
}

const mutations = {
  [EVENT_TYPE_VALUES_SET]: (state, { eventType, data } = {}) => {
    state.eventTypeValues[eventType] = data
  },
  [EVENT_TYPE_VALUES_REQ]: state => {
    state.eventTypeValuesReqStatus = 'loading'
  },
  [EVENT_TYPE_VALUES_SUCCESS]: state => {
    state.eventTypeValuesReqStatus = 'saved'
  },
  [EVENT_TYPE_VALUES_ERROR]: state => {
    state.eventTypeValuesReqStatus = 'error'
  },
  [EVENT_TYPE_VALUES_RESET_STATUS]: state => {
    state.eventTypeValuesReqStatus = ''
  }
}

const actions = {
  [EVENT_TYPE_VALUES_REQ] (context, eventType) {
    eventType = eventType.toLowerCase()

    return new Promise((resolve, reject) => {
      context.commit(EVENT_TYPE_VALUES_REQ)
      ApiRest()
        .get(`/bi/eventtype/${eventType}/values`)
        .then(({ data }) => {
          context.commit(EVENT_TYPE_VALUES_SET, { eventType: eventType, data: data })
          resolve({ eventType: eventType, data: data })
        })
        .catch(errMsg => {
          context.commit(EVENT_TYPE_VALUES_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [EVENT_TYPE_VALUES_SUCCESS] (context) {
    context.commit(EVENT_TYPE_VALUES_SUCCESS)
  },
  [EVENT_TYPE_VALUES_RESET_STATUS] (context) {
    context.commit(EVENT_TYPE_VALUES_RESET_STATUS)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/threat_hunting/eventtype-values.module.js